var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ListItem, ListItemIcon, ListItemContent, ListItemDropdown, ListItemKitchenHubLogo, } from "./components";
import AnimateHeight from "react-animate-height";
import { Doordash, GrubhubLogo, UberEatsLogo, UberLogo } from "../logo/kitchenhub-logo";
let ListBoardItem = class ListBoardItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dropped: false };
    }
    render() {
        const { props } = this;
        const { item, list } = props;
        return (React.createElement(ListItem, { onClick: () => this.setState({ dropped: !this.state.dropped }) },
            React.createElement(ListItemContent, null,
                React.createElement(ListItemIcon, null, props.renderIcon(item, list)),
                props.renderRow(item, list)),
            props.item.config.source && (props.item.config.source.values.origin === "ubereats" || props.item.config.source.values.origin === "uber") &&
                React.createElement(ListItemKitchenHubLogo, null,
                    React.createElement(UberEatsLogo, null)),
            props.item.config.source && props.item.config.source.values.origin === "doordash" &&
                React.createElement(ListItemKitchenHubLogo, null,
                    React.createElement(Doordash, null)),
            props.item.config.source && props.item.config.source.values.origin === "grubhub" &&
                React.createElement(ListItemKitchenHubLogo, null,
                    React.createElement(GrubhubLogo, null)),
            props.item.config.delivery_provider === "uber" && !props.item.config.source &&
                React.createElement(ListItemKitchenHubLogo, null,
                    React.createElement(UberLogo, null)),
            (props.renderRowDropdown) && (React.createElement(AnimateHeight, { height: this.state.dropped ? "auto" : 0 },
                React.createElement(ListItemDropdown, null, props.renderRowDropdown(item, list))))));
    }
};
ListBoardItem = __decorate([
    observer
], ListBoardItem);
export { ListBoardItem };
//# sourceMappingURL=item.js.map